import React from "react";
import { getStyles } from "../../../assets/js/utils/functions";
import { getSizedImage } from "../../../assets/js/utils/utils";
import useScreenSize, { BreakPoint } from "../../hooks/useScreenSize";
import LazyImage from "../../lazy-image";
import AnimatedHeaderText from "./animated-header-text";

interface IProps {
  subtext: string;
  headerSeries: string[][];
  image: {
    src: string;
    alt: string;
  };
}

const SectionWithMockup: React.FC<IProps> = ({ subtext, image, headerSeries }) => {
  const { screen } = useScreenSize();
  return (
    <section className="body-padding body-y-padding !pb-0 hide-for-observer">
      <div className="container">
        <div>
          <AnimatedHeaderText className="" series={headerSeries} />
          <p
            className="text-black sub-text mt-3.75 sm:mt-5 max-w-sm sm:max-w-lg anim-word-up"
            style={getStyles({ "--delay": "0.5s", "--from": "35%", "--duration": "0.75s" })}
          >
            {subtext}
          </p>
        </div>

        <div className="w-full mockup-shadow">
          <figure
            className="w-[160%] sm:w-full -mb-8 sm:-mb-10 lg:-mb-15 mt-12.5 sm:mt-16 lg:mt-20 -ml-[60%] sm:ml-0 anim-word-up"
            style={getStyles({ "--delay": "0.75s", "--from": "35%", "--duration": "1s" })}
          >
            <LazyImage
              src={getSizedImage(image.src, { [BreakPoint.xs]: "w_1500", default: "w_1900" }, screen)}
              alt={image.alt}
              className="w-full"
            />
          </figure>
        </div>
      </div>
    </section>
  );
};

export default SectionWithMockup;
